<template>
  <div class="score-block-container gap-column-lg">
      <img src="/icons/score-placeholder.svg" alt="">

      <div>
          <div class="qrw-label-sm bold v1-grey-6-color">
              {{ $t('quickstart_score.desc') }}
          </div>
          <div class="qrw-heading-xl green-5-color">
              60%
          </div>
      </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.score-block-container {
    background: var(--v1-grey-2-color);
    border-radius: 8px;

    align-items: center;

    padding: 16px;
}
</style>